import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ErroNotificacaoService } from 'src/app/erro-notificacao.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/seguranca/auth.service';
import { SecretariaService } from 'src/app/secretaria/secretaria.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  foto = '';

  exibindoMeu: any;
  exibindoSubmenu: any;
  exibindoSubmenuFinanceiro: any;
  exibindoSubmenuSecretaria: any;
  exibindoSubmenuFuncionario: any;
  exibindoSubmenuJuridico: any;

  payLoad: any;

  valorToken: any;
  token: any;

  aguardeDialog = false;
  renovarLoginDialog = false;
  nomeAssociacao = '';

  socioDataCadastro = '';
  socioBatalhaoCidade = '';
  socioPorIdade = '';

  menuAberto = true;

  constructor(
    private jwtHelper: JwtHelperService,
    private secretariaService: SecretariaService,
    private erro: ErroNotificacaoService,
    private auth: AuthService,
    private rotaNavegar: Router,
    private toasty: ToastrService
  ) {
    this.menuAberto = true;
   }

  ngOnInit() {
    this.token = localStorage.getItem('access_token_xmanager');
    this.payLoad = this.jwtHelper.decodeToken(this.token);
    window.scrollTo(0,0);
    this.buscarFotoSocio();
    this.nomeAssociacao = 'ASSOCIADO - ' + this.payLoad.nome;
    this.menuAberto = true;
  } 

  toggleMenu() {
    this.menuAberto = !this.menuAberto;
  }
  
  // Verficar a utilização  
  buscarFotoSocio() {    
    if(this.payLoad != null) {
      this.secretariaService.buscarFotoSocio(this.payLoad.id, this.token).subscribe(      
        (dados: any) => {
          if(dados) {
            this.foto = `data:image/png;base64,${dados.avatar[0].foto}`;
          } else {
            this.foto = '../../../assets/img/semfoto.jpg';
          }
        }, erro => {
          if(erro.error.error === 'invalid_token') {
            this.toasty.warning('TOKEN DE ACESSO INVÁLIDO!','ATENÇÃO!');
          } else {
            this.erro.handle(erro);
          }        
        });
    }    
  }

  logout() {
    this.auth.limparAccessToken().subscribe(
      () => {
        this.rotaNavegar.navigate(['']);
      },  erro => {
        if (erro.status === 401) {
          if (erro.error.error === 'invalid_grant') {
              this.toasty.error('NÃO AUTORIZADO, USUÁRIO NÃO LOGADO!', 'ATENÇÃO!');
              this.rotaNavegar.navigate(['']);
          } else if(erro.error.error === 'invalid_token') {
            this.toasty.error('TOKEN INVÁLIDO, USUÁRIO NÃO LOGADO!','ATENÇÃO!');
            this.rotaNavegar.navigate(['']);
          }
        }
      });
  }  
}
